<template>
  <div>
    <div>
      <el-table :data="page.list"
        stripe
        style="width: 100%">
        <el-table-column
          prop="id"
          label="ID"
          width="60">
        </el-table-column>
        <el-table-column
          prop="address"
          label="编号">
        </el-table-column>
        <el-table-column
          prop="status"
          label="项目" width="250">
        </el-table-column>
        <el-table-column
          prop="rent_name"
          label="姓名">
        </el-table-column>
        <el-table-column
          prop="name"
          label="电话">
        </el-table-column>
        <el-table-column
          prop="contract_num"
          label="位置">
        </el-table-column>
        <el-table-column
          prop="rent_time"
          label="类型">
        </el-table-column>
        <el-table-column
          prop="rent_out_time"
          label="预警">
        </el-table-column>
        <el-table-column
          prop="rent_out_time"
          label="状态">
        </el-table-column>
        <el-table-column prop="rent_out_time" label="提交时间">

        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-count="(page.p*1)"
        :page-size="page.size"
        :total="page.total"
        @current-change="getData(id,$event)">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "affairs-editor",
  data(){
    return {
      page:{
        list:[],
        p:0,
        size:0,
        total:0
      },
      fm_where:{}
    }
  },
  props:{
    id:{
      type:Number,
      default(){
        return 0
      }
    },
    where:{
      type:Object,
      default() {
        return {};
      }
    },
    is_edit:{
      type: Boolean,
      default() {
        return true
      }
    }
  },
  mounted() {
    this.getData(this.id,1);
  },
  methods:{
    getData(id,p=1){
      var that=this;
      ERP.postRequest({url:"admin/CustomerManagement/getButlerRepairList",data:{
          type:"1,2,3,4,5",
          customer_id:id,
          p:p,
          ...that.fm_where
        }},ret=>{
        if(ret.code){
          console.log(ret.data)
          that.page=ret.data;
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
    setData(){
      var that=this;
      // ERP.postRequest({url:"admin/CustomerManagement/setCheckin",data:that.form},ret=>{
      //   if(ret.code){
      //     this.$msgbox.alert(ret.msg||"修改成功")
      //   }else{
      //     this.$msgbox.alert(ret.msg||"修改失败")
      //   }
      // })
    },
  },
  watch:{
    id(n,o){
      if(n){
        this.getData(n,1);
      }
    },
    where:{
      handler(n){
        this.fm_where=n
      },
      deep:true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/affairs-editor.vue